import api from "../../../services/instanceapi";
import {ganttProjectsURL} from "../../../services/api";
import {checkErrorMessage} from "../../../utils/utils";
import {FETCH_GANTT_PROJECTS, FETCH_GANTT_PROJECTS_FAIL, IS_LOADING_GANTT_PROJECTS} from "../actionTypes";

export const loadProjectsGantt = () => async (dispatch) => {
    dispatch({
        type: IS_LOADING_GANTT_PROJECTS,
    });

    try {
        const {data} = await api.get(ganttProjectsURL());
        dispatch({
            type: FETCH_GANTT_PROJECTS,
            payload: {
                projects: data,
                status: 200,
                message: "OK"
            }
        });
        return Promise.resolve();

    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status

        if (status !== 200) {
            dispatch({
                type: FETCH_GANTT_PROJECTS_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            });
        }
        return Promise.reject(e);
    }
}